import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.NOTABLES,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.NOTABLES}/${id}`,
    method: "get",
  });
}

async function create(data) {
  return await request({
    url: ENDPOINT.NOTABLES,
    method: "post",
    data,
  });
}

async function update(data) {
  return await request({
    url: `${ENDPOINT.NOTABLES}/${data.id}`,
    method: "patch",
    data,
  });
}

async function updateMultiple(data) {
  return await request({
    url: `${ENDPOINT.NOTABLES}`,
    method: "patch",
    data,
  });
}

async function remove(data) {
  return await request({
    url: `${ENDPOINT.NOTABLES}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  updateMultiple,
  remove,
};
